import { NavigateBackLink } from '@exam-center/components';
import { useParams } from '@exam-center/router';
import { PageHeader } from '@shared/components';

export default function ProcterRequestCreationPageHeader() {
  const { examCenterCode } = useParams('/:examCenterCode/exam-proctors/requests/create');

  return (
    <PageHeader
      title='สร้างคำขออนุมัติผู้คุมสอบ'
      linkAdornment={
        <NavigateBackLink
          to='/:examCenterCode/exam-proctors/requests'
          params={{ examCenterCode }}
        />
      }
    />
  );
}
